export default "__VITE_ASSET__DXTJ_L$z__"